import { API_BASE } from "./api";

// Client for dubu-api's deposit endpoints (auth-gated; session cookies).

export type DepositChain =
  | "ETHEREUM"
  | "POLYGON"
  | "BASE"
  | "OPTIMISM"
  | "BSC"
  | "SOLANA"
  | "APTOS";

export interface DepositTokenMeta {
  token: "USDT" | "USDC";
  /** ERC-20 contract (EVM) or SPL mint (Solana). */
  contract: string;
  decimals: number;
}

export interface DepositAddress {
  chain: DepositChain;
  address: string;
  /** Empty for chains without one-click transfer metadata (Aptos, for now). */
  tokens: DepositTokenMeta[];
}

export interface DepositRecord {
  id: string;
  chain: DepositChain;
  token: string;
  amount: number;
  status: string;
  tx_hash: string | null;
  confirmations: number;
  created_at: string;
  confirmed_at: string | null;
}

const req = async <T>(path: string): Promise<T> => {
  const res = await fetch(`${API_BASE}${path}`, { credentials: "include" });
  const body = await res.json().catch(() => null);
  if (!res.ok || !body?.success) throw new Error(body?.message || `Request failed (${res.status})`);
  return body.data as T;
};

export const fetchDepositAddresses = () =>
  req<{ addresses: DepositAddress[]; note: string }>("/pro/deposits/addresses");

export const fetchDeposits = () => req<{ deposits: DepositRecord[] }>("/pro/deposits");

/** EVM chain ids for wallet chain-switching, keyed by our chain names. */
export const EVM_CHAIN_IDS: Partial<Record<DepositChain, number>> = {
  ETHEREUM: 1,
  POLYGON: 137,
  BASE: 8453,
  OPTIMISM: 10,
  BSC: 56,
};
